import scrollIntoView from 'smooth-scroll-into-view-if-needed';

import { warn } from '~/utils';

type QuizMessageData = {
  readonly id: string;
  readonly data: {
    readonly height?: number;
    readonly scrollToTop?: boolean;
  };
};

export class Quasar {
  static addMessageListener(): undefined {
    if (this.isAdded) {
      return undefined;
    }

    window.addEventListener('message', this.onMessage);
    this.isAdded = true;
  }

  static removeMessageListener(): void {
    window.removeEventListener('message', this.onMessage);
    this.isAdded = false;
  }

  private static isAdded: boolean = false;

  private static onMessage(event: MessageEvent): undefined {
    const messageFromQuiz = event.origin.includes('quiz') && typeof event.data === 'string';
    if (!messageFromQuiz) {
      return undefined;
    }

    let data: QuizMessageData;
    try {
      data = JSON.parse(event.data);

      const {
        id,
        data: { height, scrollToTop },
      } = data;
      const quizIframe = document.querySelector(`#${id}`);
      if (!(quizIframe instanceof HTMLElement)) {
        return undefined;
      }

      if (height) {
        quizIframe.style.height = height + 'px';
      }

      if (scrollToTop) {
        if (!window.location.hash.match(/comment/gm)) {
          scrollIntoView(quizIframe, {
            behavior: 'smooth',
            block: 'start',
            scrollMode: 'if-needed',
          });
        }
      }
    } catch (error) {
      warn(error);
    }
  }
}
